module.exports = __webpack_public_path__ + "static/media/lampa1.f7ec2255.jpg";